export const apiEndpoints = {
  getForecast: 'api/v1/CityTable/summary?version=',
  getContinentsList: 'api/v1/continent/continent-lists/?version=',
  getRegionsList: 'api/v1/region/region-lists/{continentId}?version=',
  getPrimaryLensList: 'api/v1/PrimaryLens/get-lens',
  getRunDates: 'api/v1/RunDate/runDate-lists/{continentId}',
  getHourlyForecastRunDates:
    'api/v1/Rundate/forecast-diff/hourly/{continentId}',
  getHourlyForecastValidDates: 'api/v1/Rundate/forecast/validdates',
  getNewsFeed: 'api/v1/news',
  getDailyForecastValues: 'api/v1/location/dailyforecastvalue',
  getHourlyForecastValues: 'api/v1/location/hourlyforecastvaluefull',
  getDailyForecastDifference: 'api/v1/location/dailyforecastdiff',
  getHourlyForecastDifference: 'api/v1/location/hourlyforecastdiff',
  getForecastAnalysis: 'api/v1/forecastanalysis',
  getCitiesList: 'api/v1/CityTable/getCities/{continent}/{region}',
  getContinentCitiesList: 'api/v1/CityTable/city-lists/{continent}',
  getForecastCommentarySummaryData:
    'api/v1/Graphics/period-forecasts/{region}/{forecastType}?version=',
  getForecastCommentaryDetailedDiscussion:
    'api/v1/Discussions/period-forecast-discussions/{continent}/{region}?version=',
  getForecastCommentaryRegionList:
    '/assets/mock/forecast-regions-list-{continent}.json',
  getLocations: 'api/v1/Discussions/period-forecast-discussions/regions',
  getDetailedDiscussionsContinents:
    '/assets/mock/forecast-detailed-discussions-continents.json',
  getCompareLocationData: 'api/v1/CompareLocation/getCompareLocation?version=',
  exportByUrlAsCSV: 'api/v1/{url}/export-csv',
  getObservationTemp:
    'api/v1/CityTable/obs/{continentId}/{regionId}/{isCustom}/{tempUnit}',
  getNormalTemp: 'api/v1/CityTable/normal',
  forecastAnalysisCSVExport: 'CityViewAnalysis/forcastAnalysis',
  forecastValuesDailyCSVExport: 'api/v1/Location/dailyforecastvalue/download',
  forecastValuesHourlyCSVExport: 'api/v1/Location/hourlyforecastvalue/download',
  getSearchLocations: 'api/v1/CityTable/search/{value}',
  getFRiskIndexData: 'api/v1/location/frisk/index',
  getHistoricalData: 'api/v1/CityTable/summary/historical/popup',
  getThresholdExceedanceData: 'api/v1/Location/frisk/thresholdexceedance',
  getProbabilityAnalysisMinMaxData: 'api/v1/Location/frisk/probabilityanalysis',
  getProbabilityAnalysisPrecipData:
    'api/v1/Location/frisk/probabilityanalysis/precip',
  getForecastPoints: 'api/v1/Location/frisk/thresholdexceedance/fcstpoints',
  getBlurbs: '/api/v1/Blurb/AllBlurbs',
  getBlurb: '/api/v1/Blurb/{id}',
  getBlurbExperts: '/api/v1/Blurb/experts',
  updateUserLastVisitTime: '/api/v1/Blurb/UpdateUserLastVisit',
  getNumberOfUnreadBlurbs: '/api/v1/Blurb/numberOfUnread',
  getBlogs: '/api/v1/Blog/blogs',
  updateBlog: '/api/v1/Blog/',
  getBlogAuthors: '/api/v1/Blog/authors',
  getBlogCategories: '/api/v1/Blog/categories',
  getNumberOfUnreadBlogs: '/api/v1/Blog/numberOfUnread',
  getThresholdExeedanceGraphInfo:
    'api/v1/Location/frisk/thresholdexceedance/graphInfo',
  getThresholdExeedanceGraph: 'api/v1/Location/frisk/thresholdexceedance/graph',
  getProbilityAnalysisGraphInfo:
    'api/v1/Location/frisk/probabilityanalysis/graphInfo',
  getIsoCountryDailyAg2Forecast: 'api/v1/WeightedIsoCountry/ag2forecast/daily',
  getIsoCountryPeriodAg2Forecast:
    'api/v1/WeightedIsoCountry/ag2forecast/period',
  getIsoCountryModelDailyForecastV2:
    'api/v2/WeightedIsoCountry/modelforecast/daily',
  getIsoCountryModelPeriodForecastV2:
    'api/v2/WeightedIsoCountry/modelforecast/period',
  getWeightedIsoCountryRegions: 'api/v1/WeightedIsoCountry/regions/{continent}',
  getWeightedIsoCountryRunDate:
    'api/v1/WeightedIsoCountry/modelforecast/rundate/{continent}',
  getDailyForecastValueHistoricalData:
    'api/v1/Location/dailyforecastvalue/historicalPopup',
  getUsGasBcfCompanyDropdown: 'api/v1/WeightedBcf/companies',
  getUsGasBcfModelsRun: 'api/v1/WeightedBcf/modelrun',
  getUsGasBcfAg2DailyForecast: 'api/v1/WeightedBcf/ag2forecast/daily',
  getUsGasBcfAg2PeriodForecast: 'api/v1/WeightedBcf/ag2forecast/period',
  getWeightedAg2DailyForecast: 'api/v1/WeightedDegreeDays/ag2forecast/daily',
  getWeightedAg2PeriodForecast: 'api/v1/WeightedDegreeDays/ag2forecast/period',
  getWeightedDegreeDaysRegions: 'api/v1/WeightedDegreeDays/regions/{continent}',
  getWeightedUsGasBcfRegions: 'api/v1/WeightedBcf/regions/{continent}',
  getWeightedDegreeModelForecastDropdown:
    'api/v1/WeightedDegreeDays/modelforecast/weighted/{continent}',
  getWeightedDegreeRunDate:
    'api/v1/WeightedDegreeDays/modelforecast/rundate/{continent}',
  getUsGasBcfRunDate: 'api/v1/WeightedBcf/modelforecast/rundate',
  getWeightedDegreeDailyModelForecast:
    'api/v1/WeightedDegreeDays/singleforecast/daily',
  getWeightedDegreePeriodModelForecast:
    'api/v1/WeightedDegreeDays/singleforecast/period',
  getWeightedDegreeSingleRunGraph:
    'api/v2/WeightedDegreeDays/singleforecast/graph',
  getWeightedDegreeSingleRunGraphWdd:
    'api/v2/WeightedDegreeDays/singleforecast/graphwdd',
  getWeightedIsoCountrySingleRunGraph:
    'api/v2/WeightedIsoCountry/singleforecast/graph',
  getWeightedModelsRun: 'api/v1/weighted/modelrun',
  getWeightedDegreeModelRunDailyForecast:
    '/assets/mock/weighted-degree-days-model-run-time-daily-forecast.json',
  getWeightedDegreeModelRunPeriodForecast:
    '/assets/mock/weighted-degree-days-model-run-time-period-forecast.json',
  getWeightedDegreeModelRunTimeDailyForecastV2:
    'api/v2/WeightedDegreeDays/modelforecast/weighted/daily',
  getWeightedDegreeModelRunTimePeriodForecastV2:
    'api/v2/WeightedDegreeDays/modelforecast/weighted/period',
  getWeightedDegreeDailySummaryView:
    'api/v1/WeightedDegreeDays/ag2forecast/daily/summary-view',
  getWeightedDegreePeriodSummaryView:
    'api/v1/WeightedDegreeDays/ag2forecast/period/summary-view',
  getWeightedDegreeExportSummaryView:
    'api/v1/WeightedDegreeDays/ag2forecast/summary-view/download',
  getUsGasBcfSingleRuntimeDailyForecast:
    'api/v1/WeightedBcf/singleforecast/daily',
  getIsoCountrySingleDailyModelForecast:
    'api/v1/WeightedIsoCountry/singleforecast/daily',
  getIsoCountrySinglePeriodModelForecast:
    'api/v1/WeightedIsoCountry/singleforecast/period',
  getIsoCountryAg2ForecastGraph: 'api/v1/WeightedIsoCountry/ag2forecast/graph',
  getUsGasBcfSingleRuntimePeriodForecast:
    'api/v1/WeightedBcf/singleforecast/period',
  getUsGasBcfModelRunTimeDailyForecast:
    'api/v1/WeightedBcf/modelforecast/daily',
  getUsGasBcfModelRunTimePeriodForecast:
    'api/v1/WeightedBcf/modelforecast/period',
  weightedISOCountryAg2ForecastCSVExport:
    'api/v1/Location/dailyforecastvalue/download',
  weightedDegreeDaysAg2ForecastCSVExport:
    'api/v1/WeightedDegreeDays/ag2forecast/download',
  weightedDegreeDaysModelSingleForecastCSVExport:
    'api/v1/WeightedDegreeDays/singleforecast/download',
  weightedDegreeDaysISOCountryAG2ForecastCSVExport:
    'api/v1/WeightedIsoCountry/ag2forecast/download',
  weightedDegreeDaysBCFAG2ForecastCSVExport:
    'api/v1/WeightedBcf/ag2forecast/download',
  weightedDegreeDaysBCFSingleForecastCSVExport:
    'api/v1/WeightedBcf/singleforecast/download',
  weightedISOCountryModelRunTimeForecastCSVExportV2:
    'api/v2/WeightedIsoCountry/modelforecast/download',
  weightedDegreeDaysModelRunTimeForecastCSVExportV2:
    'api/v2/WeightedDegreeDays/modelforecast/download',
  weightedBcfModelRunTimeForecastCSVExport:
    'api/v1/WeightedBcf/modelforecast/download',
  weightedDegreeDaysISOCountrySingleForecastCSVExport:
    'api/v1/WeightedIsoCountry/singleforecast/download',
  emailNotifications: 'api/v1/Notification/notification-email',
  notificationGroupInfo: 'api/v1/Notification/notification-group-info',
  getNotificationList: 'api/v1/Notification/notification-list',
  getAlertList: 'api/v1/Notification/alert-list',
  emailNotificationsWithEmail: 'api/v1/Notification/notification-email/{email}',
  getAllDashboards: 'api/v1/Dashboard/AllDashboards',
  getDashboard: 'api/v1/Dashboard',
  createDashboard: 'api/v1/Dashboard/new',
  deleteDashboardById: 'api/v1/Dashboard',
  updateDashboard: 'api/v1/Dashboard/edit',
  getCustomLists: 'api/v1/CustomList/profile-custom-lists',
  getSummaryRunDates: 'api/v1/RunDate/rundate-lists',
  getObsTimeStamp: 'api/v1/RunDate/obs-date',
  getPDFProduct: 'api/v1/Documents/pdf-product/{productId}/{continent}',
  getSubSeasonal: 'api/v1/StaticGraphics/subseasonal',
  getRpmGraphics: 'api/v1/StaticGraphics/renewables-graphics',
  getStaticGraphicsSubregions:
    'api/v1/StaticGraphics/subregions/{forecastType}/{continent}',
  getForecastVerification:
    'api/v1/ForecastVerifications/forecast-verifications/{continent}/{region}/{tempUnit}/{windUnit}',
  updateLastSeenNotification: 'api/v1/Notification/update-alert-state',
  getFreshLook: 'api/v1/FreshLook/freshlook',
  getFreshLookPools: 'api/v1/FreshLook/freshlook/pools',
  getFreshLookLatestRunDates: 'api/v1/FreshLook/freshlook/latest-run-dates',
  getFreshLookPrimaryRunDates: 'api/v1/FreshLook/freshlook/primary-run-dates',
  getNaRenewablesHeatMap: 'api/v1/Windcast/table',
  getNaRenewablesHeatMapForecast: 'api/v1/Windcast/run-dates',
  getNaRenewablesHeatMapCSV: 'api/v1/Documents/windcast-table/download',
  getRenewablesTableRunDates: 'api/v1/Renewables/renewables-run-dates',
  getEnhancedDataServicesApiKeys: 'api/v1/EnhancedData/api-keys',
  getForecastEvolutionTable:
    'api/v1/ForecastEvolution/forecast-evolution/table',
  getForecastEvolutionTableByModel:
    'api/v1/ForecastEvolution/forecast-evolution/table/by-model',
  getForecastEvolutionTableByValidDate:
    'api/v1/ForecastEvolution/forecast-evolution/table/by-valid-date',
  getForecastEvolutionTableModels:
    'api/v1/ForecastEvolution/forecast-evolution/fcst-sources',
  getForecastEvolutionTableValidDates:
    'api/v1/ForecastEvolution/forecast-evolution/valid-dates',
  getForecastEvolutionTableCSV:
    'api/v1/Documents/forecast-evolution-table/download',
  getForecastEvolutionTableByModelCSV:
    'api/v1/Documents/forecast-evolution-table/by-model/download',
  getForecastEvolutionTableByValidDateCSV:
    'api/v1/Documents/forecast-evolution-table/by-valid-date/download',
  getForecastEvolutionTableDailyEvolutionChartNormals:
    'api/v1/ForecastEvolution/forecast-evolution-normals/pop-up',
  getOrganizationMembers: 'api/v1/OrganizationUsers/fetch-users',
  shareDashboard: 'api/v1/Dashboard/share',
  getWSICustomLists: 'api/v1/CustomList/wsitrader-custom-lists',
  importWSICustomLists: 'api/v1/CustomList/wsitrader-custom-lists-configs',
  getWSIModelFavorites: 'api/v1/FavoriteModelPage/wsitrader-model-favorites',
  importWSIModelFavorites:
    'api/v1/FavoriteModelPage/wsitrader-model-favorite-configs',
  getWeightedDegreeDailyEc46: 'api/v1/WeightedDegreeDays/ec46/daily',
  getWeightedIsoCountryDailyEc46: 'api/v1/WeightedIsoCountry/EC46/daily',
  getWeightedIsoCountryPeriodEc46: 'api/v1/WeightedIsoCountry/EC46/period',
  getAPIDocumentation: 'api/v1/Documents/api-documentation/download',
  getAppVersion: 'api/app/version',
};
